import { useRef, useId } from 'react';
import { getTools, AccessCodes } from '@pm2/api';
import { useLeaveRevision, useCurrentCourseDescriptor } from '@pm2/course-revisions';
import { withSuspenseCache } from '@pm2/react-utils';
import { pm2ConfigStore } from '@pm2/store';
import { breakpoints } from '@ui/css';
import { FloatingActionButton } from '@ui/kit';
import { ToolboxIcon } from '@ui/kit/icons';
import { useMatchBreakpoint, useToggleState, useForceHeaderExpanded, useScrollLocking } from '@utils/react';
import { ToolboxDropdown } from './atom.dropdown.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

const Toolbox = () => {
  const isMobile = useMatchBreakpoint(breakpoints.mobile);
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);
  const dropdownId = useId();
  const [enabled, actions] = useToggleState();
  const portalId = pm2ConfigStore.useSelector(state => state.config.id);
  const previewMode = pm2ConfigStore.useSelector(state => state.previewMode);
  const leaveRevision = useLeaveRevision(useCurrentCourseDescriptor());
  const tools = withSuspenseCache(getTools(portalId, {
    previewMode
  })).filter(tool => tool.accessCode === AccessCodes.ALLOWED);
  useForceHeaderExpanded(!isMobile && enabled);
  useScrollLocking(!isMobile && enabled);
  const handleButtonClick = async () => {
    if (!enabled) {
      const intent = await leaveRevision();
      if (intent === "cancel") {
        return;
      }
      actions.enable();
    } else {
      actions.disable();
    }
  };
  const handleClose = () => {
    actions.disable();
  };
  if (tools.length === 0) {
    // hide the button if there are no portal tools available to show inside
    // the dropdown
    return null;
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(FloatingActionButton, {
      ref: buttonRef,
      tooltip: {
        ariaType: "label",
        placement: "left",
        body: "Åbn værktøjer tilknyttet portalen"
      },
      onClick: handleButtonClick,
      "aria-expanded": enabled,
      "aria-controls": dropdownId,
      children: /*#__PURE__*/jsx(FloatingActionButton.Icon, {
        children: /*#__PURE__*/jsx(ToolboxIcon, {
          height: 26
        })
      })
    }), /*#__PURE__*/jsx(ToolboxDropdown, {
      id: dropdownId,
      tools: tools,
      buttonRef: buttonRef,
      dropdownRef: dropdownRef,
      open: enabled,
      onClose: handleClose
    })]
  });
};

export { Toolbox };
//# sourceMappingURL=root.toolbox.js.map
